import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BillingService } from '../../../services/billing.service';
import { CommonGlobalService } from '../../../services/common-global.service';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  providers: [MessageService]
})
export class BillingComponent implements OnInit {

  ucid: string;
  billsOfLine: any[];
  lineName: string;
  constructor(private billingService: BillingService, private messageService: MessageService, private activatedRoute: ActivatedRoute
    , private commonGlobalService: CommonGlobalService) { }

  ngOnInit() {
    this.checkUrlToGetCode();
    this.lineName = this.commonGlobalService.lineName;

  }

  checkUrlToGetCode() {
    this.activatedRoute.params.subscribe(
      (params) => {
        let tmpip = params["ucid"];
        if (tmpip) {
          this.ucid = tmpip;
          this.getTickets(this.ucid);
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'ucid not retrieved', detail: 'unable to show page contents' });
        }
        return;
      }

    );
  }

  getTickets(quoteId: string) {
    this.billingService.getAccountBilling(quoteId).subscribe((res: any[]) => {
      if (res) {
        this.billsOfLine = res;
      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Get Bills By Line Id', detail: 'unable to get bills of that line' });

    })
  }




}
